import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";

export const Card = ({ className, ...props }) => {
  const prefixCls = "card";
  const componentCls = classnames(prefixCls, className);

  return <article className={componentCls} {...props} />;
};

Card.propTypes = {
  className: PropTypes.string,
};

export default Card;



// WEBPACK FOOTER //
// ./casper/sass/components/card/card.js